/** @format */

import { omit, size } from 'lodash';
import { get } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
export const deleteLocals = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (err) {
    console.error(err);
  }
};

export const storeLocals = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error(err);
  }
};

export const restoreLocals = (key) => {
  let value = null;

  try {
    const restored = window.localStorage.getItem(key);

    if (restored) {
      value = JSON.parse(restored);
    }
  } catch (err) {
    console.error(err);
    // If stored data is not a strigified JSON this will fail,
    // that's why we catch the error
  }

  return value;
};

export const storeLocal = (key, itemKey, value) => {
  try {
    const current = window.localStorage.getItem(key);
    const dataLocal = current ? JSON.parse(current) : {};
    const dataSave = { ...dataLocal, [itemKey]: value };
    window.localStorage.setItem(key, JSON.stringify(dataSave));
  } catch (err) {
    console.error(err);
  }
};
export const deleteLocal = (key, itemKey) => {
  try {
    const restored = window.localStorage.getItem(key);
    if (restored) {
      const dataSave = omit(restored, [itemKey]);
      window.localStorage.setItem(key, JSON.stringify(dataSave));
    }
  } catch (err) {
    console.error(err);
  }
};

export const restoreLocal = (key, itemKey) => {
  let value = null;

  try {
    const restored = window.localStorage.getItem(key);
    if (restored) {
      const data = JSON.parse(restored);

      value = get(data, itemKey);
    }
  } catch (err) {
    console.error(err);
    // If stored data is not a strigified JSON this will fail,
    // that's why we catch the error
  }

  return value;
};

export const getKeyPush = (renew = false) => {
  const key = 'app.keyPush';
  let localKeyPush = window.localStorage.getItem(key);
  if (size(localKeyPush) === 0 || renew) {
    localKeyPush = uuidv4();
    window.localStorage.setItem(key, localKeyPush);
  }
  return localKeyPush;
};
